import { optionStatusBin } from '../../../pages/daf/Adm/Dominios/utils/optionStatusBin';
import { ExportSheet } from '../core';
import { DataPreparer } from '../factory';

export class ListagemModulosSisafExportPreparer implements DataPreparer {
  async prepareForExport(selectedItems: any[]): Promise<ExportSheet[]> {
    const mainSheetData = selectedItems.map((item) => ({
      id: item.id,
      status: optionStatusBin.find((opt) => opt.value === item.status)?.label,
      modulo: item.modulo,
      descricao: item.descricao,
      interfaceDaf: item.interfaceDaf === 'S' ? 'Sim' : 'Não',
      interfaceSes: item.interfaceSes === 'S' ? 'Sim' : 'Não',
      interfaceFornecedor: item.interfaceFornecedor === 'S' ? 'Sim' : 'Não',
      submodulos: item.submodulos,
      observacoes: item.observacoes,
      usuarioRegistro: item.usuarioRegistro?.nomeCompleto || 'N/A',
      dataRegistro: item.dataRegistro,
      dataUltimaAtualizacao: item.dataUltimaAtualizacao,
      usuarioAtualizacao: item.usuarioAtualizacao?.nomeCompleto || 'N/A',
      nEdicoes: item.nEdicoes || 0,
    }));

    const mainSheet: ExportSheet = {
      name: 'Listagem de Módulos Sisaf',
      columns: {
        id: 'ID',
        status: 'Status',
        modulo: 'Módulo',
        descricao: 'Descrição',
        interfaceDaf: 'Interface DAF',
        interfaceSes: 'Interface SES',
        interfaceFornecedor: 'Interface Fornecedor',
        submodulos: 'Submódulos',
        observacoes: 'Observações',
        usuarioRegistro: 'Responsável pelo Registro',
        dataRegistro: 'Data de Registro',
        dataUltimaAtualizacao: 'Última Atualização',
        usuarioAtualizacao: 'Responsável Ult. Atualização',
        nEdicoes: 'Edições',
      },
      data: mainSheetData,
    };

    return [mainSheet];
  }
}
